import { Model } from 'pinia-orm'

import { Attr, BelongsTo, HasMany, Num, Uid } from 'pinia-orm/dist/decorators'
import { Compartment } from 'modules/Compartment/Compartment'
import { QrCode } from 'modules/QrCode/QrCode'
import { Transaction } from 'modules/Transaction/Transaction'
import { EquipmentType } from 'modules/EquipmentType/EquipmentType'
import { Client } from 'modules/Client/Client'
import { MileageUnitOfMeasure } from 'modules/MileageUnitOfMeasure/MileageUnitOfMeasure'
import { EquipmentMode } from 'modules/EquipmentMode/EquipmentMode'
import { OrgGroup } from 'modules/OrgGroup/OrgGroup'
import { Tenant } from 'modules/Tenant/Tenant'
import { Org } from 'modules/Org/Org'

export class Equipment extends Model {
  static override entity = 'equipments'

  @Uid() declare id: string
  @Num(null) declare int_id: number | null

  @Attr(null) declare name: string
  @Attr(null) declare equipment_number: number | null
  @Attr(null) declare make: string | null
  @Attr(null) declare model: string | null
  @Attr(null) declare serial: string | null
  @Attr(null) declare rego: string | null
  @Attr(null) declare asset: string | null
  @Attr(true) declare is_tank: boolean
  @Attr(null) declare client_id: string | null
  @Attr(null) declare user_id: string | null
  @Attr(null) declare equipment_type_id: string | null
  @Attr(null) declare type_custom: string | null
  @Attr(null) declare last_mileage: number | null
  @Attr(null) declare mileage_unit_of_measure_id: string | null
  @Attr(null) declare equipment_mode_id: string | null
  @Attr(true) declare active: boolean
  @Attr(null) declare last_write: string | null
  @Attr(null) declare manufacture_year: number | null
  @Attr(null) declare vin: string | null
  @Attr(null) declare cost_center: string | null
  @Attr(null) declare ein: string | null
  @Attr(null) declare last_odo_update: string | null
  @Attr(null) declare org_group_id: string | null

  @BelongsTo(() => Client, 'client_id') declare client: Client | null
  @BelongsTo(() => EquipmentType, 'equipment_type_id') declare equipmentType: EquipmentType | null
  @BelongsTo(() => MileageUnitOfMeasure, 'mileage_unit_of_measure_id') declare mileageUnitOfMeasure: MileageUnitOfMeasure | null
  @BelongsTo(() => EquipmentMode, 'equipment_mode_id') declare equipmentMode: EquipmentMode | null
  @BelongsTo(() => OrgGroup, 'org_group_id') declare orgGroup: OrgGroup | null

  @HasMany(() => Compartment, 'equipment_id') declare compartments: Compartment[]
  @HasMany(() => QrCode, 'equipment_id') declare qrCodes: QrCode[]
  @HasMany(() => Transaction, 'equipment_id') declare transactions: Transaction[]

  @Attr(null) declare tenant_id: string
  @Attr(null) declare org_id: number
  @BelongsTo(() => Tenant, 'tenant_id') declare tenant: Tenant | null
  @BelongsTo(() => Org, 'org_id') declare org: Org | null
}
